module.exports = __webpack_public_path__ + "img/JC_min.28b7987d.png";